import EtapasPage from "./EtapasPage";
import { useDispatch, useSelector } from "react-redux";
import { getEtapas } from "../../../selectors/administracao.selectors";
import { useCallback } from "react";
import { actions } from "../../../reducers/administracao/etapas.actions";
import validators from "../../../utils/validators";
import { useForm } from "react-hook-form";

const EtapasPageConnected = () => {
  const dispatch = useDispatch();
  const etapas = useSelector(getEtapas);
  const loading = etapas?.loading;
  const total = etapas?.total;
  const pagina = etapas?.page;

  const handlePagination = useCallback(
    (e, page) => {
      dispatch(actions.listarEtapas.request({ pagina: page }));
    },
    [dispatch]
  );

  const handleEdit = useCallback(
    (values) => {
      dispatch(actions.editarEtapa({ etapa: values }));
    },
    [dispatch]
  );

  const handleNew = useCallback(() => {
    dispatch(actions.novaEtapa());
  }, [dispatch]);

  const handleDelete = useCallback(
    (i) => {
      dispatch(actions.excluirEtapa.request({ idEtapa: i }));
    },
    [dispatch]
  );

  const initialValues = {
    search: "",
  };

  const rules = {
    search: validators.string({ required: false }),
  };

  const formProps = {
    ...useForm(),
    rules,
    initialValues,
  };

  const handleSearch = useCallback(
    (values) => {
      const request = {
        by: "codigo",
        value: values.search,
      };
      dispatch(actions.buscarEtapa.request({ search: request, pagina: 1 }));
    },
    [dispatch]
  );

  return (
    <EtapasPage
      etapas={etapas.list}
      etapa={etapas.etapa}
      loading={loading}
      total={total}
      handlePagination={handlePagination}
      pagina={pagina}
      handleNew={handleNew}
      handleEdit={handleEdit}
      formProps={formProps}
      handleSearch={handleSearch}
      handleDelete={handleDelete}
    />
  );
};

export default EtapasPageConnected;
